import { apiClient } from './authService';

const fournisseurService = {
  getAll: async (params = {}) => {
    const queryParams = new URLSearchParams(params).toString();
    const url = queryParams ? `/fournisseurs/?${queryParams}` : '/fournisseurs/';
    const response = await apiClient.get(url);
    return response.data;
  },

  getAllWithoutPagination: async () => {
    const response = await apiClient.get('/fournisseurs/all/');
    return response.data;
  },

  getById: async (id) => {
    const response = await apiClient.get(`/fournisseurs/${id}/`);
    return response.data;
  },

  create: async (data) => {
    const response = await apiClient.post('/fournisseurs/', data);
    return response.data;
  },

  update: async (id, data) => {
    const response = await apiClient.put(`/fournisseurs/${id}/`, data);
    return response.data;
  },

  delete: async (id) => {
    const response = await apiClient.delete(`/fournisseurs/${id}/`);
    return response.data;
  },

  getProducts: async (fournisseurId) => {
    const response = await apiClient.get(`/consommables/?supplier=${fournisseurId}`);
    return response.data;
  },
};

export default fournisseurService;
